import { initLocale, PATHS } from '@ctcells/core'

/*
 * 🔴 `main.tsx` 의 **첫 import** 여야 한다 — `@ctcells/ui` 가 평가되기 전에 언어가 서야 모듈 최상위의 `t()` 도 고른 언어를 읽는다.
 *    언어 목록은 앱이 선언한다(eric 2026-11-02 「일단 통합만」). 모듈 앱 3종 · 장비 관점 앱은 이 파일이 없어 한국어뿐이다.
 * 🔴 태블릿(`/tablet`)은 이 앱 안에 있지만 한국어 그대로다. 태블릿에는 언어를 고를 설정 화면도 없다.
 * 🔴 **콘솔의 기본 언어는 영어다**(eric 2026-11-02 「디폴트를 영어로」) — 저장값이 없을 때만이다. 한국어를 골라 저장했으면 그대로 한국어.
 *    사전에 없는 키가 한국어로 떨어지는 대체 사전(`DEFAULT_LOCALE` = ko)은 그대로다.
 */
const tablet =
  window.location.pathname === PATHS.tablet ||
  window.location.pathname.startsWith(`${PATHS.tablet}/`)

if (tablet) initLocale(['ko'])
else initLocale(['ko', 'en'], 'en')
